import React, { Component, Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import styles from "./styles";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";

class LoadingIndicatorComponent extends Component {
  render() {
    return (
      <Fragment>
        {this.props.working && (
          <Grid
            container
            justify="center"
            alignItems="center"
            spacing={0}
            className={this.props.classes.progressContainer}
          >
            <Grid item xs={2} className={this.props.classes.progressItem}>
              <Typography gutterBottom variant="h6">
                {this.props.children}
              </Typography>
              <CircularProgress size={50} />
            </Grid>
          </Grid>
        )}
      </Fragment>
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  LoadingIndicatorComponent
);
